import './TripAdvisor.css';
import React from 'react';
import LazyPicture from '../LazyPicture';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
const TripAdvisor = _ref => {
  let {
    imageRatingSRC,
    score,
    alt,
    tripadvisorReviews,
    tripadvisorPrice,
    reviewCaption
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  if (!imageRatingSRC || imageRatingSRC === undefined || imageRatingSRC === '') return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-tripAdvisor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-tripAdvisor__left"
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    className: "p-tripadvisor"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: imageRatingSRC
  }), /*#__PURE__*/React.createElement("img", {
    className: "rating-img",
    src: imageRatingSRC,
    alt: alt,
    title: score
  })), tripadvisorReviews && /*#__PURE__*/React.createElement("strong", {
    className: "c-tripAdvisor__reviews"
  }, Number(tripadvisorReviews).toLocaleString(), " ", reviewCaption)), tripadvisorPrice && /*#__PURE__*/React.createElement("span", {
    className: "c-tripAdvisor__price"
  }, tripadvisorPrice), tripadvisorPrice && /*#__PURE__*/React.createElement("span", {
    style: {
      width: '47px;'
    }
  })));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `c-tripAdvisor-wrapper ${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "c1j7jg9";
const ltrStyles = "lvpxnzf";
const rtlStyles = "rwh89zg";
export default TripAdvisor;